'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var PropTypes = require('prop-types');

var index = require('../../../external/classnames/index.js');

var Button = require('../../../primitives/Button/Button.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SplitBannerContent = function SplitBannerContent(props) {
  var buttonLink = props.buttonLink,
      buttonLinkTwo = props.buttonLinkTwo,
      buttonTargetTwo = props.buttonTargetTwo,
      buttonText = props.buttonText,
      buttonTextTwo = props.buttonTextTwo,
      category = props.category,
      children = props.children,
      className = props.className,
      description = props.description,
      hasImage = props.hasImage,
      isHTML = props.isHTML,
      title = props.title,
      target = props.target;
  var classes = index['default']('lanl-splitbanner-content', hasImage && 'has-image', className);

  var renderDescription = function renderDescription() {
    return description && (isHTML ? /*#__PURE__*/React__default['default'].createElement("div", {
      className: "lanl-splitbanner-description",
      dangerouslySetInnerHTML: {
        __html: description
      }
    }) : /*#__PURE__*/React__default['default'].createElement("p", {
      className: "lanl-splitbanner-description"
    }, description));
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes
  }, category && /*#__PURE__*/React__default['default'].createElement("p", {
    className: "lanl-splitbanner-category"
  }, category), title && /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "lanl-splitbanner-title"
  }, title), renderDescription(), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "lanl-splitbanner-inner"
  }, buttonLink && buttonLink !== '' && buttonText && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
    href: buttonLink,
    target: target,
    color: "secondary"
  }, buttonText), buttonLinkTwo && buttonLinkTwo !== '' && buttonTextTwo && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
    href: buttonLinkTwo,
    target: buttonTargetTwo,
    outline: true,
    color: "white"
  }, buttonTextTwo), children));
};

SplitBannerContent.defaultProps = {
  isHTML: false,
  buttonTargetTwo: '_self',
  target: '_self',
  hasImage: false
};
SplitBannerContent.propTypes = {
  buttonLink: PropTypes__default['default'].string,
  buttonLinkTwo: PropTypes__default['default'].string,
  buttonTargetTwo: PropTypes__default['default'].string,
  buttonText: PropTypes__default['default'].string,
  buttonTextTwo: PropTypes__default['default'].string,
  category: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  description: PropTypes__default['default'].string,
  hasImage: PropTypes__default['default'].bool,
  isHTML: PropTypes__default['default'].bool,
  target: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string
};
exports.SplitBannerContent = SplitBannerContent;
exports['default'] = SplitBannerContent;